let thumbnail = $(".entry-header");
let scrollBottom = $(".scroll-bottom");
let navigationMenu = $('#site-navigation');



const btn = document.getElementById("menu-toggle");
const nav = document.querySelector("#site-navigation");
const lines = btn.querySelectorAll(".line_hamburger");
const cls = { open: "open", close: "close" };
let btnClass = cls.open;
btn.addEventListener("click", () => {

	// nav.classList.add('animate__fadeInRight')
	if (btn.getAttribute('aria-expanded') === "true") {
		nav.classList.remove('animate__backInRight')
		nav.classList.add('animate__backOutLeft')
		btn.classList.remove(btnClass);
		btnClass = cls.close;
		btn.setAttribute('aria-expanded', "false");
		closeMenu()
		$('body').css('overflow', 'unset')

	}
	else if(btn.getAttribute('aria-expanded') === "false"){
		nav.classList.add('animate__backInRight')
		nav.classList.remove('animate__backOutLeft')
		btn.setAttribute('aria-expanded', "true");
		btn.classList.remove(btnClass);
		btnClass = cls.open;
		openMenu()
		$('body').css('overflow', 'hidden')
	}

	void btn.offsetWidth;
	btn.classList.add(btnClass);
});



function openMenu() {
    let links = navigationMenu.find('.nav-link')
    let copyright  = navigationMenu.find('.copyright')
    let adresse  = navigationMenu.find('.adresse')
    let socialLinks  = navigationMenu.find('.social-links')

    links.each(function (index, element) {
        offset = 200 * (index - 1)
        $(element).css('animation-delay', offset+'ms')
        $(element).css('animation-duration', '600ms')
    })
    links.addClass('animate__animated animate__backInRight')
	copyright.addClass('animate__animated animate__zoomIn')
	adresse.addClass('animate__animated animate__zoomIn')
	socialLinks.addClass('animate__animated animate__backInRight')
}
function closeMenu() {
    let links = navigationMenu.find('.nav-link')
	let copyright  = navigationMenu.find('.copyright')
	let adresse  = navigationMenu.find('.adresse')
	let socialLinks  = navigationMenu.find('.social-links')
    links.removeClass('animate__animated animate__backInRight')
	copyright.removeClass('animate__animated animate__zoomIn')
	adresse.removeClass('animate__animated animate__zoomIn')
	socialLinks.removeClass('animate__animated animate__backInRight')
}


//Disable empty link
$('#site-navigation .nav-link').each(function () {
    // console.log($(this).attr('href'))
    if ($(this).attr('href') == '') {
        $(this).css('pointer-events', 'none')
    }
})


